import React from "react";
// Assets
// import ContactImg1 from "../../assets/img/contact-1.png";
// import ContactImg2 from "../../assets/img/contact-2.png";
// import ContactImg3 from "../../assets/img/contact-3.png";

export default function Contact() {
  return (
    <section id="contact" className="w-full bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="py-16">
          <h1 className="text-3xl font-extrabold">Kontakt</h1>
          <p className="text-base mt-2">Nehmen Sie kontakt mit uns auf!</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pb-8 text-left">
          <div className="md:col-span-1 grid content-center">
            <h5 className="text-lg font-semibold"><a className="block" href="tel:015164731867">Tel: 0151 647 31 867</a></h5>
            <h5 className="text-lg font-semibold"><a className="block" href="mailto:info@xhosha-erdbewegungen.de">info@xhosha-erdbewegungen.de</a></h5>
            <p>Adenauerstr. 20, 82178 Puchheim</p>
            <div className="flex">
              <dt className="w-1/5 text-left">Mo - Fr</dt>
              <dd className="w-4/5 text-left"><time>9:00 am</time> - <time>5:00 pm</time></dd>
            </div>
            <div className="flex">
              <dt className="w-1/5 text-left">Sa - So</dt>
              <dd className="w-4/5 text-left">Geschlossen</dd>
            </div>
          </div>
          <div className="md:col-span-2">
            <iframe title="location" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2660.9523999010526!2d11.351899415943613!3d48.1689986569505!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479e78b2f9cdf8f5%3A0x478dbea4d81f764!2sAdenauerstra%C3%9Fe%2020%2C%2082178%20Puchheim!5e0!3m2!1sen!2sde!4v1677798842265!5m2!1sen!2sde" width="100%" height="450" className="mt-6 border border-gray-200 rounded-lg" allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}










